import { render, staticRenderFns } from "./SchoolTestPage.vue?vue&type=template&id=168ebb69&scoped=true&lang=pug&"
import script from "./SchoolTestPage.vue?vue&type=script&lang=ts&"
export * from "./SchoolTestPage.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolTestPage.vue?vue&type=style&index=0&id=168ebb69&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168ebb69",
  null
  
)

export default component.exports